<template>
  <div class="race-question">
    <modal name="quote" @before-close="onClose">    
      <div style="padding: 20px;">
        <div class="image">
          <img src="https://contattafiles.s3-us-west-1.amazonaws.com/tnt8888/hIf7gIIFd6jb9AY/q.png" alt="Question Image"/>
          <h1>Today's Quote</h1>   
        </div>
        <textarea v-model="todayQuote.quote" id="Quote" maxlength="17" name="quote" Placeholder="enter quote here"></textarea>
        <div>
          <button class="btn btn--primary"  v-on:click="Save()" v-if=" !isQuoteExist">Save</button>
          <button class="btn btn--primary"  v-on:click="Update()" v-if=" isQuoteExist">Update</button>
        </div>
      </div>
    </modal>
    
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
import DatePicker from '@/components/DatePicker/DatePicker'

 import moment from 'moment'
  export default {
    
    name: 'quote',
    data: () => ({
     quote: '',
     isquestionId: false,
     isSaved:false,
    //  date: {
    //    time: moment().format('YYYY-MM-DD')
    //  },
     time: {},
     button:'',
    }),
    props:{
      show:false,
      isQuoteExist:{ type: Boolean},
      todayQuote:{
        type: Object,
        default: function () {
          return { quote:null }
        }
      },
      date:{
        // type: Object,
        // default: function () {
        //   return { time: moment().format('YYYY-MM-DD') }
        // }
        },
      raceId:null
    },
    
    mounted() {
        //this.$parent.$emit('closed', true)
    },
    methods: {
      onClose() {
        this.$parent.$emit('closed', true)
        this.$emit('saved', true)
      },
      Save: function(){
            var raceQuote ={
                      // id: this.todayQuote.id,
                      date: this.date.time,                   
                      quote: this.todayQuote.quote
                    }
            this.createRaceQuote(raceQuote)
              .then((e) => {         
                this.$emit('saved', e)
                this.$modal.hide('quote')
                
              })
              .catch(() => {
                 console.log('failed')
              })
              
      },
      Update: function(){
            var raceQuote ={
                      id: this.todayQuote.id,
                      date: this.date.time,                   
                      quote: this.todayQuote.quote
                    }
            this.updateRaceQuote(raceQuote)
              .then((e) => {
                this.$emit('saved', e)
                this.$modal.hide('quote')
                
              })
              .catch(() => {
                 console.log('failed')
              })
              
      },
      test(){
       this.$emit('tapped', true)
      
      },
      ...mapActions({
        createRaceQuote: 'RaceQuote/createOne',
        updateRaceQuote: 'RaceQuote/updateOne',
        getRaceQuote: 'RaceQuote/getOne'
      })
    },
    
    watch: {
      show(oldVal, newVal) {
        if (this.show)
        if(this.todayQuote.date){
          this.date.time = this.todayQuote.date
        }
          this.$modal.show('quote')
      }
    },
    Save () {
    },
    created() {
      this.$watch('show', function (val) {
      })
    },
    components: {
      DatePicker
    }
  }
</script>
<style>

#Quote {
  width: 100% !important;
  border: 1px solid #ccc;
  padding: 9px 0 7% 15px;
  border-radius: 5px;
}
.save-update button {
    margin: 0 0 0 15px;
}
.save-update {
    /* float: right; */
    width: 70%;
    /* padding: 15px 0 0 0; */
}
.date label {
    position: relative;
    top: 6px;margin: 0 15px 0 0px;
}
/* .sweet-modal.is-alert .sweet-content {
    padding-top: 30px!important;
    padding-bottom: 30px!important;
} */
/* .date {
    float: left;
    padding: 15px 0 0 0;
    width: 30%;
} */
/* .sweet-modal{padding:0;} */

</style>



// WEBPACK FOOTER //
// Quote.vue?16911950